module.exports = __webpack_public_path__ + "img/AstroFrens13.188262c4.jpg";